import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PROJECTS, CATEGORIES, wixImg } from "../data/projects";
import { useSEO } from "../lib/seo";

const CAT_SEO = {
  lakohazak: "Családi házak és lakóházak építészeti tervezése – megvalósult referenciáink képekkel.",
  tarsashazak: "Társasházak építészeti tervezése beruházóknak – megvalósult referenciáink képekkel.",
  kozepuletek: "Középületek, panziók és ipari épületek tervezése – megvalósult referenciáink képekkel.",
};

const CategoryPage = () => {
  const { category } = useParams();
  const cat = CATEGORIES.find((c) => c.key === category);
  useSEO(
    cat ? `${cat.label} – Építészeti referenciák | New Idea Architect` : "Referenciák | New Idea Architect",
    CAT_SEO[category] || "Megvalósult építészeti projektjeink.",
    `/portfolio/${category}`
  );
  if (!cat) return <Navigate to="/munkaink" replace />;
  const projects = PROJECTS[category] || [];

  return (
    <main className="flex flex-col gap-2.5 pb-2.5 pt-2.5">
      {/* Fekete fejléc box a világos háttéren */}
      <section className="px-2.5">
        <div className="rounded-2xl bg-[var(--card-dark)] p-8 sm:p-12">
          <Link
            to="/munkaink"
            className="inline-flex items-center gap-2 text-white/80 text-sm font-bold hover:text-[var(--accent)] transition-colors mb-6"
          >
            <ArrowLeft size={16} /> VISSZA
          </Link>
          <h1 className="text-white heading-font font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tight uppercase">
            {cat.label}
          </h1>
        </div>
      </section>

      {/* Masonry – természetes képarány, nincs crop */}
      <section className="px-2.5">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-2.5">
          {projects.map((p, i) => (
            <Link
              key={p.slug}
              to={`/portfolio/${category}/${p.slug}`}
              className="relative block mb-2.5 break-inside-avoid rounded-xl overflow-hidden group bg-[var(--tile-ph)]"
            >
              <img
                src={wixImg(p.cover, 700)}
                alt={p.name}
                loading={i < 3 ? "eager" : "lazy"}
                decoding="async"
                className="w-full h-auto block"
              />
              <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-5 pt-14">
                <span className="text-white font-bold text-lg">{p.name}</span>
              </span>
              <span className="absolute inset-0 rounded-xl ring-0 group-hover:ring-4 ring-[var(--accent)] ring-inset transition-shadow duration-200 pointer-events-none" />
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default CategoryPage;
